var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-loader"},[(!_vm.loading)?_c('div',[_vm._t("default")],2):_c('div',[_c('img',{staticClass:"background-loader",attrs:{"src":_vm.backgroundUrl,"alt":"Loader"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }